import $ from "jquery";
// import Vue from 'vue'

const Alerts = {
  info: function (error) {
    this.show(error.title, error.detail, "info");
  },
  danger: function (error) {
    this.show(error.title, error.detail, "danger");
  },
  warning: function (error) {
    this.show(error.title, error.detail, "warning");
  },
  primary: function (error) {
    this.show(error.title, error.detail, "primary");
  },
  success: function (error) {
    this.show(error.title, error.detail, "success");
  },

  show: function (title, message, type = "info") {
    let alert = $(`<div class="alert alert-${type}">
       <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <strong> ${title} </strong> <br>
         ${message}
      </div>
    `);

    setTimeout(() => {
      alert.fadeOut();
    }, 5000);

    alert.appendTo($(".alert-hover"));
  },
};
function handle(fun) {
  async function nested() {
    try {
      return await fun.apply(this, arguments);
    } catch (res) {
      console.log("handle", res, res.errors);
      console.log(res.response);

      if (res.response && res.response.data) {
        // eslint-disable-next-line no-ex-assign
        res = res.response.data;
      }

      // JSONAPI errors
      if (res.errors) {
        res.errors.forEach((e) => {
          Alerts.danger(e);
        });
      } else if (res.error) {
        //
        Alerts.danger({ title: res.error, detail: res.exception });
      } else {
        Alerts.danger({ title: res, detail: "" });

        throw res;
      }
    }
  }

  return nested;
}

window.Alerts = Alerts;

export default Alerts;
export { handle };
